import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import { Grid, IconButton, Typography, useTheme } from '@mui/material';
import prettyBytes from 'pretty-bytes';

import { TenantPortalAttachment } from '../../types/tenant-portal';
import theme from '../../utilities/theme';
import Loader from '../common/Loader';

type AttachmentItemProps = {
  attachment: TenantPortalAttachment;
  onRemove: (attachment: TenantPortalAttachment) => void;
  error?: boolean;
  loading?: boolean;
};

const AttachmentItem = (props: AttachmentItemProps) => {
  const theme = useTheme();
  return (
    <Grid container sx={styles.mainContainer}>
      <Grid item>
        <InsertPhotoOutlinedIcon
          sx={{
            color:
              props.loading || props.error
                ? theme.palette.secondary.main
                : theme.palette.primary.main,
          }}
        />
      </Grid>

      <Grid item sx={{ flex: 1 }}>
        <Grid container sx={styles.columnContainer}>
          <Grid item>
            <Grid container sx={styles.attachmentContainer}>
              <Grid item>
                <Grid container sx={styles.columnContainer}>
                  <Grid item>
                    <Typography variant='subtitle2' fontWeight='bold'>
                      {props.attachment.file.name}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant='caption'>
                      {prettyBytes(props.attachment.file.size)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <IconButton onClick={() => props.onRemove(props.attachment)}>
                  <DeleteOutlineOutlinedIcon sx={styles.greyText} />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>

          {props.loading && !props.error && (
            <Grid item sx={styles.paddingTop}>
              <Loader />
            </Grid>
          )}
          {props.error && (
            <Grid item>
              <Typography variant={'caption'} color={'error'}>
                There was an issue with this upload.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AttachmentItem;

const styles = {
  mainContainer: {
    alignItems: 'center',
    columnGap: 2,
    border: '2px #E9E9E9 solid',
    padding: 2,
    borderRadius: 2,
  },
  greyText: {
    color: theme.palette.secondary.main,
  },
  columnContainer: {
    flexDirection: 'column',
  },
  attachmentContainer: {
    columnGap: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
  },
  paddingTop: {
    paddingTop: 2,
  },
};
